import html from './overlay.html';
import {partial} from '../../../utils/partial';
import {emitter, EVENTS} from '../../../utils/emitter';
import {uiContainer} from '../../../configs/global';

export class LandscapeOverlay {
  private element: HTMLElement;

  constructor() {
    this.element = partial(html);
    this.render();
  }

  private render() {
    const parent = document.querySelector(uiContainer);
    parent.append(this.element);
  }

  // private addHandlers() {
  //   emitter.on(EVENTS.resize, this.onResize);
  // }

  // private onResize = () => {
  //   console.log('resize');
  // }
}
